<div class="banner-container" [ngStyle]="{'background-color': color}">
  <img class="image" [src]="icon" alt="Image">
  <span class="text-input">{{text}}</span>

</div>
